import AnimatedBackground from "./AnimatedBackground";
import logoBranca from "../assets/logo-branca.png";

/**
 * Tela cheia do PORTÃO DE ACESSO (Fase 2).
 *  - "checking": verificando acesso no Portal (não pisca o app).
 *  - "denied":   usuário sem acesso a este sistema -> volta ao Portal.
 *  - "error":    falha de rede ao falar com o Portal -> não libera, sem loop.
 */
interface Props {
  state: "checking" | "denied" | "error";
  onBackToPortal: () => void;
}

export default function AccessGate({ state, onBackToPortal }: Props) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 20,
        padding: 24,
        textAlign: "center",
        background: "linear-gradient(135deg, #064e3b 0%, #065f46 55%, #047857 100%)",
        color: "#ecfdf5",
      }}
    >
      <AnimatedBackground />

      <img
        src={logoBranca}
        alt="SERCAMP"
        style={{ height: 56, opacity: 0.95, marginBottom: 8 }}
      />

      {state === "checking" && (
        <>
          <div
            aria-hidden="true"
            style={{
              width: 38,
              height: 38,
              borderRadius: "50%",
              border: "3px solid rgba(255,255,255,0.25)",
              borderTopColor: "#fff",
              animation: "ag-spin 0.8s linear infinite",
            }}
          />
          <p style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>
            Verificando acesso...
          </p>
          <style>{"@keyframes ag-spin{to{transform:rotate(360deg)}}"}</style>
        </>
      )}

      {state === "denied" && (
        <>
          <h1 style={{ fontSize: 24, fontWeight: 700, margin: 0 }}>
            Acesso negado
          </h1>
          <p style={{ fontSize: 16, maxWidth: 460, margin: 0, lineHeight: 1.5 }}>
            Você não tem acesso a este sistema. Fale com o Admin Supremo.
          </p>
          <button onClick={onBackToPortal} style={btnStyle}>
            Voltar ao Portal
          </button>
        </>
      )}

      {state === "error" && (
        <>
          <h1 style={{ fontSize: 24, fontWeight: 700, margin: 0 }}>
            Não foi possível verificar o acesso
          </h1>
          <p style={{ fontSize: 16, maxWidth: 460, margin: 0, lineHeight: 1.5 }}>
            Não conseguimos falar com o Portal para confirmar suas permissões.
            Verifique sua conexão e tente novamente.
          </p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", justifyContent: "center" }}>
            <button onClick={() => window.location.reload()} style={btnStyle}>
              Tentar novamente
            </button>
            <button onClick={onBackToPortal} style={btnGhostStyle}>
              Voltar ao Portal
            </button>
          </div>
        </>
      )}
    </div>
  );
}

const btnStyle: React.CSSProperties = {
  padding: "11px 22px",
  borderRadius: 10,
  border: "none",
  background: "#fff",
  color: "#065f46",
  fontSize: 15,
  fontWeight: 600,
  cursor: "pointer",
};

const btnGhostStyle: React.CSSProperties = {
  padding: "11px 22px",
  borderRadius: 10,
  border: "1px solid rgba(255,255,255,0.55)",
  background: "transparent",
  color: "#fff",
  fontSize: 15,
  fontWeight: 600,
  cursor: "pointer",
};
